export const range = (stop: number): Array<number> => [...new Array(stop).keys()]

export const zip = <T1, T2>(arr1: Array<T1>, arr2: Array<T2>): Array<[T1, T2]> => {
  const zipped = new Array<[T1, T2]>()
  const length = Math.min(arr1.length, arr2.length)
  for (let i = 0; i < length; i++) zipped.push([arr1[i], arr2[i]])
  return zipped
}
